import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import { FaPills, FaEdit, FaTrash, FaTimes, FaPlus } from "react-icons/fa";
import MasterLayout from "../../../components/layout/MasterLayout";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";
import "../../../assets/css/donordashboard/MedicineDonate.css";

const MedicineDonate = () => {
  const { baseUrl, loggedInDonorId } = useContext(AppContext); // ✅ FIX — loggedInDonorId add kiya

  const [donations, setDonations]   = useState([]);
  const [loading, setLoading]       = useState(false);
  const [editId, setEditId]         = useState(null);
  const [showForm, setShowForm]     = useState(false);

  const [donorName, setDonorName]               = useState("");
  const [donorType, setDonorType]               = useState("");
  const [medicineName, setMedicineName]         = useState("");
  const [medicineCategory, setMedicineCategory] = useState("");
  const [quantity, setQuantity]                 = useState("");
  const [quantityUnit, setQuantityUnit]         = useState("");
  const [expiryDate, setExpiryDate]             = useState("");
  const [description, setDescription]           = useState("");
  const [pickupAddress, setPickupAddress]       = useState("");
  const [city, setCity]                         = useState("");
  const [contactNumber, setContactNumber]       = useState("");
  const [pickupDate, setPickupDate]             = useState("");
  const [availableTime, setAvailableTime]       = useState("");
  const [isUnopened, setIsUnopened]             = useState(false);
  const [agreeTerms, setAgreeTerms]             = useState(false);

  useEffect(() => {
    if (loggedInDonorId) {
      viewAllDonations();
    }
  }, [loggedInDonorId]);

  const validateForm = () => {
    if (!donorName || !donorType || !medicineName || !medicineCategory ||
        !quantity || !quantityUnit || !expiryDate || !description ||
        !pickupAddress || !city || !contactNumber || !pickupDate || !availableTime) {
      Swal.fire({ title: "Required!", text: "Please fill all fields", icon: "warning" });
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (editId) { updateDonation(); } else { createDonation(); }
  };

  // ── CREATE — donor_id append karo ──────────────────────────────────────
  const createDonation = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("donor_id",        loggedInDonorId); // ✅ FIX — donor_id add kiya
    formData.append("donor_name",        donorName);
    formData.append("donor_type",        donorType);
    formData.append("medicine_name",     medicineName);
    formData.append("medicine_category", medicineCategory);
    formData.append("quantity",          quantity);
    formData.append("quantity_unit",     quantityUnit);
    formData.append("expiry_date",       expiryDate);
    formData.append("description",       description);
    formData.append("pickup_address",    pickupAddress);
    formData.append("city",              city);
    formData.append("contact_number",    contactNumber);
    formData.append("pickup_date",       pickupDate);
    formData.append("available_time",    availableTime);
    formData.append("is_unopened",       isUnopened ? 1 : 0);
    formData.append("agree_terms",       agreeTerms ? 1 : 0);

    axios.post(`${baseUrl}/donor/dashboard/createMedicine`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => {
        if (response.data.success) {
          Swal.fire({ title: "Success!", text: "Medicine Donation Created Successfully", icon: "success" });
          viewAllDonations();
          resetForm();
        } else {
          Swal.fire({ title: "Oops!", text: "Cannot Create Donation", icon: "error" });
        }
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  };

  // ── VIEW ALL — donor_id param ke saath filter ──────────────────────────
  const viewAllDonations = () => {
    axios.get(`${baseUrl}/donor/dashboard/viewAllMedicine`, {
      params: { donor_id: loggedInDonorId }, // ✅ FIX — sirf is donor ki donations
    })
      .then((response) => {
        if (response.data.success) setDonations(response.data.donations);
      })
      .catch((error) => console.log(error));
  };

  // ── UPDATE — donor_id append karo ──────────────────────────────────────
  const updateDonation = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("id",                editId);
    formData.append("donor_id",          loggedInDonorId); // ✅ FIX — donor_id add kiya
    formData.append("donor_name",        donorName);
    formData.append("donor_type",        donorType);
    formData.append("medicine_name",     medicineName);
    formData.append("medicine_category", medicineCategory);
    formData.append("quantity",          quantity);
    formData.append("quantity_unit",     quantityUnit);
    formData.append("expiry_date",       expiryDate);
    formData.append("description",       description);
    formData.append("pickup_address",    pickupAddress);
    formData.append("city",              city);
    formData.append("contact_number",    contactNumber);
    formData.append("pickup_date",       pickupDate);
    formData.append("available_time",    availableTime);
    formData.append("is_unopened",       isUnopened ? 1 : 0);
    formData.append("agree_terms",       agreeTerms ? 1 : 0);

    axios.post(`${baseUrl}/donor/dashboard/updateMedicine`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => {
        if (response.data.success) {
          Swal.fire({ title: "Updated!", text: "Medicine Donation Updated Successfully", icon: "success" });
          viewAllDonations();
          resetForm();
        }
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  };

  const deleteDonation = (id) => {
    Swal.fire({
      title: "Are You Sure?", text: "This medicine donation will be deleted!", icon: "warning",
      showCancelButton: true, confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("id",       id);
        formData.append("donor_id", loggedInDonorId); // ✅ FIX
        axios.post(`${baseUrl}/donor/dashboard/deleteMedicine`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
          .then((response) => {
            if (response.data.success) {
              Swal.fire({ title: "Deleted!", text: "Donation Deleted Successfully", icon: "success" });
              viewAllDonations();
            }
          })
          .catch((error) => console.log(error));
      }
    });
  };

  const handleEdit = (don) => {
    setEditId(don.id);
    setDonorName(don.donor_name);
    setDonorType(don.donor_type);
    setMedicineName(don.medicine_name);
    setMedicineCategory(don.medicine_category);
    setQuantity(don.quantity);
    setQuantityUnit(don.quantity_unit);
    setExpiryDate(don.expiry_date);
    setDescription(don.description);
    setPickupAddress(don.pickup_address);
    setCity(don.city);
    setContactNumber(don.contact_number);
    setPickupDate(don.pickup_date);
    setAvailableTime(don.available_time);
    setIsUnopened(don.is_unopened == 1);
    setAgreeTerms(don.agree_terms == 1);
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setEditId(null);
    setDonorName(""); setDonorType(""); setMedicineName(""); setMedicineCategory("");
    setQuantity(""); setQuantityUnit(""); setExpiryDate(""); setDescription("");
    setPickupAddress(""); setCity(""); setContactNumber(""); setPickupDate("");
    setAvailableTime(""); setIsUnopened(false); setAgreeTerms(false);
    setShowForm(false);
  };

  // ── Status badge using me- classes (avoids bootstrap Badge bg collision) ──
  const getStatusBadge = (status) => {
    const map = {
      pending:   { label: "Pending",   cls: "me-status-pending"   },
      verified:  { label: "Verified",  cls: "me-status-verified"  },
      collected: { label: "Collected", cls: "me-status-collected" },
      cancelled: { label: "Cancelled", cls: "me-status-cancelled" },
    };
    const s = map[(status || "pending").toLowerCase()] || map["pending"];
    return (
      <span className={`me-status-badge ${s.cls}`}>
        <span className="me-status-dot"></span>
        {s.label}
      </span>
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    return new Date(dateStr).toLocaleDateString("en-PK", {
      day: "2-digit", month: "short", year: "numeric",
    });
  };

  return (
    <MasterLayout>
      <Container fluid className="py-4 me-medicine-donation-container">

        {/* Header */}
        <div className="me-page-header">
          <div className="me-header-content">
            <h3 className="me-page-title" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <FaPills /> Donate Medicine
            </h3>
            <p className="me-page-subtitle">Share your unused or surplus medicines with those in need</p>
          </div>
          <button
            className={showForm ? "me-close-btn-header" : "me-add-btn"}
            onClick={() => {
              if (showForm) { resetForm(); } else { setShowForm(true); }
            }}
          >
            {showForm
              ? <><FaTimes /> Close Form</>
              : <><FaPlus /> Add Medicine</>
            }
          </button>
        </div>

        {/* Form Card */}
        {showForm && (
          <div className="me-form-card mb-5">
            <div className="me-form-header">
              {editId
                ? <><FaEdit /> Update Medicine Donation</>
                : <><FaPlus /> Add New Medicine Donation</>
              }
            </div>
            <div className="me-form-card-body">
              <Form onSubmit={handleSubmit}>
                <Row className="g-3">

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="me-form-label">Donor Name <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="me-form-input" type="text" placeholder="e.g., Ali Hassan" value={donorName} onChange={(e) => setDonorName(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="me-form-label">Donor Type <span className="text-danger">*</span></Form.Label>
                      <Form.Select className="me-form-input" value={donorType} onChange={(e) => setDonorType(e.target.value)}>
                        <option value="">Select Type</option>
                        <option value="individual">Individual</option>
                        <option value="hospital">Hospital</option>
                        <option value="pharmacy">Pharmacy</option>
                        <option value="ngo">NGO</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="me-form-label">Medicine Name <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="me-form-input" type="text" placeholder="e.g., Panadol" value={medicineName} onChange={(e) => setMedicineName(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="me-form-label">Medicine Category <span className="text-danger">*</span></Form.Label>
                      <Form.Select className="me-form-input" value={medicineCategory} onChange={(e) => setMedicineCategory(e.target.value)}>
                        <option value="">Select Category</option>
                        <option value="general_medicine">General Medicine</option>
                        <option value="chronic_disease">Chronic Disease</option>
                        <option value="pediatric">Pediatric</option>
                        <option value="antibiotics">Antibiotics</option>
                        <option value="vitamins">Vitamins & Supplements</option>
                        <option value="surgical">Surgical / First Aid</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="me-form-label">Quantity <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="me-form-input" type="number" placeholder="e.g., 10" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="me-form-label">Unit <span className="text-danger">*</span></Form.Label>
                      <Form.Select className="me-form-input" value={quantityUnit} onChange={(e) => setQuantityUnit(e.target.value)}>
                        <option value="">Unit</option>
                        <option value="strips">Strips</option>
                        <option value="bottles">Bottles</option>
                        <option value="boxes">Boxes</option>
                        <option value="units">Units</option>
                        <option value="vials">Vials</option>
                        <option value="sachets">Sachets</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="me-form-label">Expiry Date <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="me-form-input" type="date" value={expiryDate} onChange={(e) => setExpiryDate(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="me-form-label">Contact Number <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="me-form-input" type="text" placeholder="03XX-XXXXXXX" value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="me-form-label">City <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="me-form-input" type="text" placeholder="e.g., Lahore" value={city} onChange={(e) => setCity(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={8}>
                    <Form.Group>
                      <Form.Label className="me-form-label">Pickup Address <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="me-form-input" type="text" placeholder="Full pickup address" value={pickupAddress} onChange={(e) => setPickupAddress(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="me-form-label">Pickup Date <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="me-form-input" type="date" value={pickupDate} onChange={(e) => setPickupDate(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="me-form-label">Available Time <span className="text-danger">*</span></Form.Label>
                      <Form.Select className="me-form-input" value={availableTime} onChange={(e) => setAvailableTime(e.target.value)}>
                        <option value="">Select Time</option>
                        <option value="morning">Morning (8AM - 12PM)</option>
                        <option value="afternoon">Afternoon (12PM - 4PM)</option>
                        <option value="evening">Evening (4PM - 8PM)</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="me-form-label">Description <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="me-form-input" as="textarea" rows={3} placeholder="Describe the medicine condition, storage, etc." value={description} onChange={(e) => setDescription(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Check className="me-form-check" type="checkbox" label="Medicine is Unopened / Sealed" checked={isUnopened} onChange={(e) => setIsUnopened(e.target.checked)} />
                  </Col>

                  <Col md={6}>
                    <Form.Check className="me-form-check" type="checkbox" label="I agree to the terms and conditions" checked={agreeTerms} onChange={(e) => setAgreeTerms(e.target.checked)} />
                  </Col>

                  <Col md={12}>
                    <div className="me-form-actions">
                      <button type="button" className="me-cancel-btn" onClick={resetForm}>Cancel</button>
                      <button type="submit" className="me-submit-btn" disabled={loading}>
                        {loading ? "Please wait..." : editId ? "Update Donation" : "Submit Donation"}
                      </button>
                    </div>
                  </Col>

                </Row>
              </Form>
            </div>
          </div>
        )}

        {/* Table */}
        <div className="me-table-section">
          <div className="me-table-header-row">
            <div className="me-table-title-group">
              <div className="me-table-title-icon">
                <FaPills color="#fff" size={18} />
              </div>
              <div>
                <p className="me-table-heading">All Medicine Donations ({donations.length})</p>
                <p className="me-table-subheading">Track and manage your medicine donation requests</p>
              </div>
            </div>
          </div>

          <div className="me-table-card">
            <div className="me-table-wrapper">
              <table className="me-donation-table">
                <thead>
                  <tr>
                    <th className="me-th">#</th>
                    <th className="me-th">Donor Name</th>
                    <th className="me-th">Donor Type</th>
                    <th className="me-th">Medicine</th>
                    <th className="me-th">Category</th>
                    <th className="me-th">Quantity</th>
                    <th className="me-th">Expiry</th>
                    <th className="me-th">City</th>
                    <th className="me-th">Contact</th>
                    <th className="me-th">Pickup Date</th>
                    <th className="me-th">Time Slot</th>
                    <th className="me-th">Unopened</th>
                    <th className="me-th">Status</th>
                    <th className="me-th">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {donations.length === 0 ? (
                    <tr>
                      <td colSpan={14} className="me-td-empty">
                        <div className="me-empty-state">
                          <span className="me-empty-icon">💊</span>
                          <p>No medicine donations found. Add your first donation above!</p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    donations.map((don, index) => (
                      <tr key={don.id} className={index % 2 === 0 ? "me-tr-even me-tr" : "me-tr-odd me-tr"}>
                        <td className="me-td me-td-num">{index + 1}</td>
                        <td className="me-td me-td-name">{don.donor_name}</td>
                        <td className="me-td" style={{ textTransform: "capitalize" }}>{don.donor_type}</td>
                        <td className="me-td me-td-name">{don.medicine_name}</td>
                        <td className="me-td">
                          <span className="me-category-pill">
                            {(don.medicine_category || "").replace("_", " ")}
                          </span>
                        </td>
                        <td className="me-td me-td-qty">
                          {don.quantity} <span className="me-qty-unit">{don.quantity_unit}</span>
                        </td>
                        <td className="me-td">{formatDate(don.expiry_date)}</td>
                        <td className="me-td me-td-city">{don.city}</td>
                        <td className="me-td">{don.contact_number}</td>
                        <td className="me-td">{formatDate(don.pickup_date)}</td>
                        <td className="me-td" style={{ textTransform: "capitalize" }}>{don.available_time}</td>
                        <td className="me-td">
                          {don.is_unopened == 1
                            ? <span className="me-yes-pill">Yes</span>
                            : <span className="me-no-pill">No</span>
                          }
                        </td>
                        <td className="me-td">{getStatusBadge(don.donation)}</td>
                        <td className="me-td">
                          <div className="me-action-btns">
                            <button className="me-action-icon-btn me-edit-icon" onClick={() => handleEdit(don)} title="Edit">
                              <FaEdit size={13} />
                            </button>
                            <button className="me-action-icon-btn me-delete-icon" onClick={() => deleteDonation(don.id)} title="Delete">
                              <FaTrash size={13} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </Container>
    </MasterLayout>
  );
};

export default MedicineDonate;